'use client'

import { SessionProvider, useSession } from 'next-auth/react'
import { ReactNode } from 'react'

export function AuthProvider({ children }: { children: ReactNode }) {
  return <SessionProvider>{children}</SessionProvider>
}

export function useAuth() {
  const { data: session, status } = useSession()
  
  return {
    userData: session?.user || null,
    loading: status === "loading"
  }
} 


// USE

// import { useAuth } from '@/providers/AuthProvider'

// export default function SeuComponente() {
//   const { userData, loading } = useAuth()

//   if (loading) return <div>Carregando...</div>

//   return (
//     <div>
//       <h1>Olá, {userData?.name}</h1>
//       <img src={userData?.avatar} alt="Avatar" />
//       {/* ... resto do componente ... */}
//     </div>
//   )
// }